import styled from 'styled-components/macro';

// import theme helpers
import { getColor } from '../../../util/theme';

const FooterInfo = styled.div`
  span {
    color: ${getColor('white')};
    font-size: 1.6rem;

    padding: 0 10px;
  }
`;

export default FooterInfo;
